const limitedNumberLength = (value, previousValue, limit) => {
  if (value && +value !== 0) {
    if (value.toString().match(new RegExp(`^(\\d{0,${limit}})$`))) {
      return parseInt(value, 10).toString();
    }
    return previousValue;
  }
  return '';
};

export const maxThreeDigit = (value, previousValue) => limitedNumberLength(value, previousValue, 5);

export default {
  maxThreeDigit
};
